import React from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { formulaSection } from '../data/mock';

const FormulaSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-32 bg-gradient-to-b from-[#0d1f1f] to-[#1a3334] relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.05) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 relative z-10">
        <div className="text-center space-y-12">
          {/* Title */}
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
            {language === 'en' ? formulaSection.title_en : formulaSection.title_es}
          </h2>

          {/* Formula */}
          <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl p-12 md:p-16 border border-gray-700/50 shadow-2xl">
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-3xl md:text-5xl font-bold">
              <span className="text-white hover:text-emerald-400 transition-colors cursor-default">Fitness</span>
              <X className="text-emerald-400 w-8 h-8" />
              <span className="text-white hover:text-emerald-400 transition-colors cursor-default">Nutrition</span>
              <X className="text-emerald-400 w-8 h-8" />
              <span className="text-white hover:text-emerald-400 transition-colors cursor-default">Wellbeing</span>
              <X className="text-emerald-400 w-8 h-8" />
              <span className="text-white hover:text-emerald-400 transition-colors cursor-default">Football</span>
              <span className="text-emerald-400">=</span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Longevity</span>
            </div>
          </div>

          {/* Quote */}
          <div className="max-w-4xl mx-auto pt-8">
            <blockquote className="text-xl md:text-2xl text-gray-400 italic leading-relaxed">
              {language === 'en' ? formulaSection.description_en : formulaSection.description_es}
            </blockquote>
            <div className="text-emerald-400 font-semibold mt-6">
              — {formulaSection.quote_author}
            </div>
          </div>

          {/* Decorative Elements */}
          <div className="flex justify-center items-center space-x-4 pt-12">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="w-3 h-3 rounded-full bg-emerald-400/30 hover:bg-emerald-400 transition-all duration-300 cursor-pointer"
                style={{ animationDelay: `${i * 0.2}s` }}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormulaSection;